/**
 * 混入插件
 * */

export default {
  /**
   * 改变route地址
   * @param {Array | Object} config 要改变的配置 ['k', 'k2'] <=> {k: 'k', k2: 'k2'}
   *                                   => 对象key为地址上的key，value为映射到当前页面对象的key
   * @param {'query' | 'params'} [type='query' | 'params'] 改变的route的参数对象
   * @param {'push' | 'replace'} [linkType='push' | 'replace'] 跳转方式
   * */
  MakeRoute(config, type = 'query', linkType = 'push') {
    Array.isArray(config) && (config = config.reduce((r, c) => ({...r, [c]: c}), {}));
    let res = {
      computed: {},
    };
    if (typeof config === 'object') {
      Object.keys(config).forEach(urlProp => {
        let currProp = config[urlProp];
        res.computed[currProp] = {
          get() {
            return this.$route[type][urlProp];
          },
          set(val) {
            let {name, params, query} = this.$route;
            let linkTo = {name, params, query};
            linkTo[type] = {...linkTo[type], [urlProp]: val};
            this.$router[linkType](linkTo);
          }
        }
      })
    }
    return res;
  },

  /**
   * 监听滚动事件（app） 触发自定义钩子 appScroll(event)
   * @param {String | Number}  [query='#app'] 要监听的dom节点 query (用于document.querySelector(query)获取节点)
   *                                          （类型为number时 time = query ; query 为#app节点query
   * @param {Number} [time=300] 延时触发毫秒数 0 时为不延时
   * @return {Object}
   */
  AppScroll(query = '#app', time = 300) {
    if (typeof query === 'number') {
      time = query;
      query = '#app';
    }
    let key = '__SCROLL' + +new Date();
    let timer = null;
    return query ? {
      methods: {
        [key](e) {
          clearTimeout(timer);
          timer = setTimeout(() => {
            this.$options.appScroll.call(this, e);
          }, time);
        },
      },
      mounted() {
        let dom = document.querySelector(query);
        if (typeof this.$options.appScroll === 'function') {
          dom.removeEventListener('scroll', this[key]);
          dom.addEventListener('scroll', this[key]);
        }
      },
      beforeDestroy() {
        let dom = document.querySelector(query);
        if (typeof this.$options.appScroll === 'function') {
          dom.removeEventListener('scroll', this[key]);
        }
      },
    } : {};
  },
}